import { Entity } from '@core/data/dto/entity';
import { Moment } from 'moment';
import { DeliveryOrderRefundStatus } from '../delivery-order-refund-status';
import { DtoImport, DtoExport } from '@core/utils/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { DeliveryOrderRefundSchema } from './delivery-order-refund.schema';
import { Dto } from '@core/data/dto/dto';

export class DeliveryOrderRefund implements Entity {
    public status: DeliveryOrderRefundStatus;
    public dspApprovedAt: Moment;
    public dspApprovedAmount: number;
    public requestAt: Moment;
    public refundNote: string;
    public resolvedAt: Moment;
    public requesterId: string;
    public refundAmount: number;
    public rejectReason: string;
    public requesterName: string;
    public supportNote: string;
    public label?: string;

    @DtoImport(DeliveryOrderRefundSchema)
    static import(dto: Dto): any {}

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderRefundSchema,
        },
    ])
    export(type?: DtoType): any {}

    public getStatusLabel() {
        switch (this.status) {
            case DeliveryOrderRefundStatus.APPROVED:
                return 'Orders.List.Refund.Approved';

            case DeliveryOrderRefundStatus.DSP_APPROVED:
                return 'Orders.List.Refund.DspApproved';

            case DeliveryOrderRefundStatus.PENDING:
                return 'Orders.List.Refund.Pending';

            case DeliveryOrderRefundStatus.REJECTED:
                return 'Orders.List.Refund.Rejected';

            default:
                return '';
        }
    }
}
